import React from "react";
import { Stack, Typography } from "@mui/material";

export interface InfoCardProps {
  icon?: string;
  heading?: string;
  description?: string;
}
const InfoCard = ({ icon, heading, description }: InfoCardProps) => {
  return (
    <Stack display="flex" flexDirection="column" spacing={3}>
      <Stack
        width="77px"
        height="77px"
        justifyContent="center"
        alignItems="center"
        style={{ backgroundColor: "#B1D238", borderRadius: "38px" }}
      >
        <i className={`${icon} font-white fa-3x`} />
      </Stack>
      <Stack>
        <Typography variant="h2" fontWeight={700}>
          {heading}
        </Typography>
      </Stack>
      <Stack height="190px">
        <Typography>{description}</Typography>
      </Stack>
      <Stack style={{ borderBottom: "1px solid #B1D238", width: " 93px" }}>
        <Typography variant="h4" color="primary" fontWeight={700}>
          Learn More
        </Typography>
      </Stack>
    </Stack>
  );
};
export default InfoCard;
